import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ac6472d60bf8499d116e1898089e7219db from "./generated-bd6d3981-82a5-47f9-a83b-7d622f909d90.json";

import a7652c26593ca4c2fe1fadf85a80a95ffb from "./generated-4d937457-3f37-4f12-b749-3e917901aeba.json";

import a989537eaadad70463cf321c1c028f9a4b from "./generated-14570b6d-cab4-400f-b0fd-e30afecdb34c.json";

import ad1a32af390c9fea1893ab45d56c1c760b from "./generated-0a357231-4053-4c08-aa9b-fa9e856d2b34.json";

import ae8890f3735b2e92f6332455c17b932b5b from "./generated-bdffba82-161e-42da-94d3-554bf62b85ec.json";

import a7a3f8bfc090947a033b36f78ef4834f3b from "./generated-3a212735-2347-4964-be5d-f3ca79bce1de.json";

import acda950793b0e46937ef3d8e7d1d728a6b from "./generated-347fbe6f-7c76-4824-bef7-3306427f05f7.json";

import a63d0d8fb29ea61e492c5c709410ab0fcb from "./generated-9d24331a-9a48-497f-b4ee-966206c3bc8b.json";

import a096d21b0da46350d1c909302cf5db8afb from "./generated-70bf26ac-c259-4880-9fcb-1018695e228d.json";

import ae56f2c88f613ee4411d48b5e2691f25fb from "./generated-272e4ee9-fde0-4e8f-ac61-fc6eee1852ab.json";

import a474c410caddce72c0fbbe17d6c10a449b from "./generated-d8bf2e02-5578-4da9-a406-f7338b247000.json";

import a2c3eed16e0492fd169a14b29e50d1541b from "./generated-25bc1a6c-5bc0-4a64-bffb-86d66f02426a.json";

import a85436929545276a67f5479aa980e70b8b from "./generated-4aeb1990-5532-41c9-992a-6b69b6c04165.json";

import a0449b6f234245fb42723ccb7def5a91db from "./generated-9dfa44d8-db2f-4689-b423-4bc754f33757.json";

import af9665f26e47216cae62a0d9a4d618302b from "./generated-09f92a37-275a-4a4c-88ce-b05d3203218f.json";

import abe59e38dc0961c76c8f0ae750019ec8ab from "./generated-bf36a120-2d0f-45a9-b108-0d3c316fb1a3.json";

import a9f91926c8f8363f55758bfed232d7de1b from "./generated-2fc2a6e2-6f58-40bc-8e55-16c37a744fdd.json";

import a370f08d121ae5c2af0ff62cbce720088b from "./generated-95a6ab0f-bb17-42e3-ad8c-30706d881bae.json";

import ac3156a39f23158be4c02f4a10083a492b from "./generated-f1bb0aa7-0515-4fab-b8b7-11d53dd9e284.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ac6472d60bf8499d116e1898089e7219db);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a7652c26593ca4c2fe1fadf85a80a95ffb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a989537eaadad70463cf321c1c028f9a4b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ad1a32af390c9fea1893ab45d56c1c760b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ae8890f3735b2e92f6332455c17b932b5b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a7a3f8bfc090947a033b36f78ef4834f3b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(acda950793b0e46937ef3d8e7d1d728a6b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a63d0d8fb29ea61e492c5c709410ab0fcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a096d21b0da46350d1c909302cf5db8afb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ae56f2c88f613ee4411d48b5e2691f25fb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a474c410caddce72c0fbbe17d6c10a449b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a2c3eed16e0492fd169a14b29e50d1541b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a85436929545276a67f5479aa980e70b8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a0449b6f234245fb42723ccb7def5a91db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(af9665f26e47216cae62a0d9a4d618302b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(abe59e38dc0961c76c8f0ae750019ec8ab);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a9f91926c8f8363f55758bfed232d7de1b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a370f08d121ae5c2af0ff62cbce720088b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ac3156a39f23158be4c02f4a10083a492b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a9f91926c8f8363f55758bfed232d7de1b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */